import { render, staticRenderFns } from "./finishReceiptOrPayment.vue?vue&type=template&id=32b6ef96&scoped=true&"
import script from "./finishReceiptOrPayment.vue?vue&type=script&lang=js&"
export * from "./finishReceiptOrPayment.vue?vue&type=script&lang=js&"
import style0 from "./finishReceiptOrPayment.vue?vue&type=style&index=0&id=32b6ef96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b6ef96",
  null
  
)

component.options.__file = "finishReceiptOrPayment.vue"
export default component.exports